import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

import {
  RecurringLockedMessage,
  ReportTemplateLockedMessage,
} from 'dashboard/forms/FormReportTemplate/ReportTemplateMessage';
import Spacer from 'design-system/components/Spacer';
import Sticker from 'design-system/components/Sticker';
import TabBar, { Tab } from 'design-system/components/TabBar';
import useToggle from 'lib/hooks/useToggle';

interface RecurringReportFormWrapperProps {
  configContent: ReactNode;
  recurringContent: ReactNode;
  continuousEnabled: boolean;
  canEdit: boolean;
}

const RecurringReportFormWrapper = ({
  configContent,
  recurringContent,
  continuousEnabled,
  canEdit,
}: RecurringReportFormWrapperProps) => {
  const [configTab, { enable: showConfigTab, disable: hideConfigTab }] = useToggle(true);

  return (
    <>
      <TabBar>
        <Tab
          id='recurring-report-form-wrapper__tab-config'
          selected={configTab}
          onClick={showConfigTab}
        >
          Configuration
        </Tab>
        <Tab
          id='recurring-report-form-wrapper__tab-recurring'
          selected={!configTab}
          badge={<StyledSticker variant='grey'>{continuousEnabled ? 'On' : 'Off'}</StyledSticker>}
          onClick={hideConfigTab}
        >
          Continuous monitoring
        </Tab>
      </TabBar>
      <Spacer height={3} />
      {!canEdit && (
        <>
          <ReportTemplateLockedMessage />
          <Spacer height={2} />
        </>
      )}
      {canEdit && !configTab && (
        <>
          <RecurringLockedMessage />
          <Spacer height={2} />
        </>
      )}

      <div style={{ display: configTab ? 'block' : 'none' }}>{configContent}</div>
      <div style={{ display: !configTab ? 'block' : 'none' }}>{recurringContent}</div>
    </>
  );
};

const StyledSticker = styled(Sticker)`
  margin-left: ${Spacing[2]};
`;

export default RecurringReportFormWrapper;
